import request from '@/utils/request';

export function unBinding(params) {
  return request({
    url: `/icbc/organization/unbind`,
    method: 'post',
    params
  });
}
